import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { fadeInOut, smoothHeight } from '../../../../animations';
import { ActivatedRoute } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { User_default_user_get_collection } from '../../../../api_types';
import { ApiResponse, ApiServiceInterface, CrudComponent, CrudOptions, FormServiceInterface, ModalsServiceInterface, QueryServiceInterface } from '@hutsix/ngxh6';
import { MacUserService } from '../../../../services/user/mac-user.service';

@Component({
    selector: 'app-users',
    templateUrl: './users.component.html',
    styleUrls: ['./users.component.scss'],
    animations: [smoothHeight, fadeInOut],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class UsersComponent extends CrudComponent implements OnInit, OnDestroy {
    public unsubscribe$ = new Subject<void>();

    public response$: Observable<ApiResponse<User_default_user_get_collection[]>>;
    public response: ApiResponse<User_default_user_get_collection[]>;

    public opts: CrudOptions = {
        title: 'Manage Staff',
        icon: 'fa-users',
        objectLabel: 'User',
        formSlug: 'user',
        apiEndpoint: '/api/v1/users',
        queryKey: 'user',
        apiClassName: 'App\\Entity\\User',
        hideHeader: false,
    };

    constructor(private route: ActivatedRoute) {
        super();
    }

    trackById(index, id): any {
        return id;
    }

    ngOnInit(): void {
        if (this.route.snapshot.data.apiEndpoint) this.opts.apiEndpoint = this.route.snapshot.data.apiEndpoint;
        super.ngOnInit();
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
